import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function Navbar() {
  const { user, logout } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navRef = useRef(null);

  const handleToggle = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setDropdownOpen(false);
      }
      if (navRef.current && !navRef.current.contains(event.target)) {
        setMenuOpen(false);
        setDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const renderLinks = () => (
    <>
      {!user && (
        <>
          <Link to="/signup" onClick={closeMenu} className="block px-4 py-2 font-montserrat text-primary font-bold hover:text-clay">Sign Up</Link>
          <Link to="/login" onClick={closeMenu} className="block px-4 py-2 font-montserrat text-primary font-bold hover:text-clay">Login</Link>
          <Link to="/search" onClick={closeMenu} className="block px-4 py-2 font-montserrat text-primary font-bold hover:text-clay">Search</Link>
        </>
      )}

      {user && (
        <>
          <Link to="/dashboard" onClick={closeMenu} className="block px-4 py-2 font-montserrat text-primary hover:text-clay">Dashboard</Link>
          <Link to="/search" onClick={closeMenu} className="block px-4 py-2 font-montserrat text-primary hover:text-clay">Search</Link>
          <Link to="/profile" onClick={() => { setDropdownOpen(false); closeMenu(); }} className="block px-4 py-2 font-montserrat text-primary hover:text-clay">My Profile</Link>
          <Link to="/post-horse" onClick={() => { setDropdownOpen(false); closeMenu(); }} className="block px-4 py-2 font-montserrat text-primary hover:text-clay">Post Horse</Link>
          <button onClick={() => { logout(); closeMenu(); setDropdownOpen(false); navigate('/login');}} className="block px-4 py-2 font-montserrat text-primary hover:text-clay">Logout</button>
          {/*<div ref={dropdownRef} className="relative">
            <button
              onClick={() => setDropdownOpen(!dropdownOpen)}
              className="block px-4 py-2 font-montserrat text-primary hover:text-clay"
            >
              My App ▾
            </button>
            {dropdownOpen && (
              <div className="absolute bg-white border rounded shadow-md mt-1 z-10 w-40">
                <Link to="/wishlist" onClick={() => { setDropdownOpen(false); closeMenu(); }} className="block px-4 py-2 hover:bg-gray-100 text-sm">Wishlist</Link>
                <Link to="/post-horse" onClick={() => { setDropdownOpen(false); closeMenu(); }} className="block px-4 py-2 hover:bg-gray-100 text-sm">Post Horse</Link>
                <Link to="/bids" onClick={() => { setDropdownOpen(false); closeMenu(); }} className="block px-4 py-2 hover:bg-gray-100 text-sm">My Bids</Link>
                <Link to="/profile" onClick={() => { setDropdownOpen(false); closeMenu(); }} className="block px-4 py-2 hover:bg-gray-100 text-sm">My Profile</Link>
                <button
                  onClick={() => {
                    logout();
                    closeMenu();
                    setDropdownOpen(false);
                    navigate('/login');
                  }}
                  className="block w-full text-left px-4 py-2 text-red-500 hover:bg-gray-100 text-sm"
                >
                  Logout
                </button>
              </div>
            )}
          </div>*/}
        </>
      )}
    </>
  );

  return (
    <nav ref={navRef} className="bg-light px-4 py-4">
      <div className="flex justify-between items-center max-w-7xl m-auto">
        <Link to="/" className="text-5xl font-med text-primary font-cormorant">
          Cantrysa
        </Link>

      {/* Mobile toggle button */}
        {user && (  
          <button
            className="text-primary md:hidden text-3xl"
            onClick={handleToggle}
            aria-label="Toggle Menu"
          >
            {menuOpen ? 'X' : '☰'}
          </button>
          )
        }

        {/* Desktop nav */}
        <div className="hidden md:flex space-x-4 items-center">
          {renderLinks()}
        </div>
      </div>

      {/* Mobile dropdown nav */}
      {menuOpen && (
        <div className="md:hidden mt-4 border-t pt-2">
          {renderLinks()}
        </div>
      )}
    </nav>
  );
}

export default Navbar;